import {ListItem} from "@domain/common/list-view/list-item";

/**
 * Modèle du message admin
 *
 * @author Lionel Gimenez
 * @date 24/03/2026
 */
export class MessageAdmin implements ListItem {
    /** Identifiant unique du message dans la base de données */
    idMessage: number;

    /** Objet du message */
    objet: string;

    /** Type de message */
    type: number;

    /** Contenu du message */
    message: string;

    /** Indicateur d'activation */
    actif: boolean;

    /** Date de début */
    dateDebut: Date;

    /** Date de fin */
    dateFin: Date;

    /** Indicateur d'envoi par email */
    email: boolean;

    /** Date d'envoi */
    dateEnvoi: Date;

    /** Nombre de rôles */
    nbRoles: number;

    getKey(): number {
        return this.idMessage;
    }
}

/**
 * Enumération des types de message
 */
export enum MessageAdminType {
    INFORMATION = 1,
    CONFIRMATION = 2,
    AVERTISSEMENT = 3,
    ALERTE = 4
}
